import { api } from "../../Config/ApiConfig";

export const verifyEmail = async (token) => {
    const { data } = await api.post('/auth/verify-email', { token });
    return data;
};